"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var components_1 = require("stremio/components");
var services_1 = require("stremio/services");
var components_2 = require("../components");
var usePlayerOptions_1 = __importDefault(require("./usePlayerOptions"));
var common_1 = require("stremio/common");
var Player = (0, react_1.forwardRef)(function (_a, ref) {
    var profile = _a.profile;
    var shell = (0, services_1.useServices)().shell;
    var platform = (0, common_1.usePlatform)();
    var _b = (0, usePlayerOptions_1.default)(profile), subtitlesLanguageSelect = _b.subtitlesLanguageSelect, subtitlesSizeSelect = _b.subtitlesSizeSelect, subtitlesTextColorInput = _b.subtitlesTextColorInput, subtitlesBackgroundColorInput = _b.subtitlesBackgroundColorInput, subtitlesOutlineColorInput = _b.subtitlesOutlineColorInput, audioLanguageSelect = _b.audioLanguageSelect, surroundSoundToggle = _b.surroundSoundToggle, seekTimeDurationSelect = _b.seekTimeDurationSelect, seekShortTimeDurationSelect = _b.seekShortTimeDurationSelect, playInExternalPlayerSelect = _b.playInExternalPlayerSelect, nextVideoPopupDurationSelect = _b.nextVideoPopupDurationSelect, bingeWatchingToggle = _b.bingeWatchingToggle, playInBackgroundToggle = _b.playInBackgroundToggle, hardwareDecodingToggle = _b.hardwareDecodingToggle, videoModeSelect = _b.videoModeSelect, pauseOnMinimizeToggle = _b.pauseOnMinimizeToggle;
    return (react_1.default.createElement(components_2.Section, { ref: ref, label: 'SETTINGS_NAV_PLAYER' },
        react_1.default.createElement(components_2.Category, { icon: 'subtitles', label: 'SETTINGS_SECTION_SUBTITLES' },
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_SUBTITLES_LANGUAGE' },
                react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, subtitlesLanguageSelect))),
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_SUBTITLES_SIZE' },
                react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, subtitlesSizeSelect))),
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_SUBTITLES_COLOR' },
                react_1.default.createElement(components_1.ColorInput, __assign({ className: 'color-input' }, subtitlesTextColorInput))),
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_SUBTITLES_COLOR_BACKGROUND' },
                react_1.default.createElement(components_1.ColorInput, __assign({ className: 'color-input' }, subtitlesBackgroundColorInput))),
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_SUBTITLES_COLOR_OUTLINE' },
                react_1.default.createElement(components_1.ColorInput, __assign({ className: 'color-input' }, subtitlesOutlineColorInput)))),
        react_1.default.createElement(components_2.Category, { icon: 'volume-medium', label: 'SETTINGS_SECTION_AUDIO' },
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_DEFAULT_AUDIO_TRACK' },
                react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, audioLanguageSelect))),
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_SURROUND_SOUND' },
                react_1.default.createElement(components_1.Toggle, __assign({ tabIndex: -1 }, surroundSoundToggle)))),
        react_1.default.createElement(components_2.Category, { icon: 'remote', label: 'SETTINGS_SECTION_CONTROLS' },
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_SEEK_KEY' },
                react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, seekTimeDurationSelect))),
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_SEEK_KEY_SHIFT' },
                react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, seekShortTimeDurationSelect))),
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_PLAY_IN_BACKGROUND' },
                react_1.default.createElement(components_1.Toggle, __assign({ disabled: true, tabIndex: -1 }, playInBackgroundToggle)))),
        react_1.default.createElement(components_2.Category, { icon: 'play', label: 'SETTINGS_SECTION_AUTO_PLAY' },
            react_1.default.createElement(components_2.Option, { label: 'AUTO_PLAY' },
                react_1.default.createElement(components_1.Toggle, __assign({ tabIndex: -1 }, bingeWatchingToggle))),
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_NEXT_VIDEO_POPUP_DURATION' },
                react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, nextVideoPopupDurationSelect)))),
        react_1.default.createElement(components_2.Category, { icon: 'glasses', label: 'SETTINGS_SECTION_ADVANCED' },
            react_1.default.createElement(components_2.Option, { label: 'SETTINGS_PLAY_IN_EXTERNAL_PLAYER' },
                react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, playInExternalPlayerSelect))),
            shell.active &&
                react_1.default.createElement(components_2.Option, { label: 'SETTINGS_HWDEC' },
                    react_1.default.createElement(components_1.Toggle, __assign({ tabIndex: -1 }, hardwareDecodingToggle))),
            shell.active && platform.name === 'windows' &&
                react_1.default.createElement(components_2.Option, { label: 'SETTINGS_VIDEO_MODE' },
                    react_1.default.createElement(components_1.MultiselectMenu, __assign({ className: 'multiselect' }, videoModeSelect))),
            shell.active &&
                react_1.default.createElement(components_2.Option, { label: 'SETTINGS_PAUSE_MINIMIZED' },
                    react_1.default.createElement(components_1.Toggle, __assign({ tabIndex: -1 }, pauseOnMinimizeToggle))))));
});
exports.default = Player;
